import { Core } from "@/core/Core";

export default {
  async getCompanyExternalPos(context, {branchId, companyId}) {
    try {
      return await Core.request("GET", `/api/branches/${branchId}/companies/${companyId}/external-pos`);
    } catch (e) {
      return null;
    }
  },

  async saveCompanyExternalPos(context, {branchId, companyId, data}) {
    try {
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}/external-pos`, data);
    } catch (e) {
      return null;
    }
  },

  async saveCompanyTunnel(context, {branchId, companyId, data}) {
    try {
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}/tunnel`, data);
    } catch (e) {
      return null;
    }
  },

  async checkExternalPosConnection(context, {posName, posConfig}) {
    try {
      return await Core.request("GET", `/api/external-pos/${posName}/check-connection`, posConfig);
    } catch (e) {
      return null;
    }
  },

  async retryExternalPosConnection(context, {companyId}) {
    try {
      return await Core.request("GET", `/api/company/${companyId}/retry-connexion`);
    } catch (e) {
      return null;
    }
  },

  async syncInventory(context,  {branchId, companyId, posName, data}) {
    try {
      return await Core.request("PUT", `/api/branches/${branchId}/companies/${companyId}/external-pos/${posName}/sync-inventory`, data);
    } catch (e) {
      return null;
    }
  },

  async syncFromXmlForMaitreDExternalPos(context, {branchId, companyId, data}) {
    try {
      console.log('data', data);
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}/maitred/sync-from-xml`, data);
    } catch (e) {
      return null;
    }
  },

  async uploadXmlForMaitreDExternalPos(context, {branchId, companyId, data}) {
    try {
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}/maitred/upload-xml`, data);
    } catch (e) {
      return null;
    }
  },

  async generateReportForMaitreDExternalPos(context, {branchId, companyId, data}) {
    try {
      return await Core.request("PUT",`/api/branches/${branchId}/companies/${companyId}/maitred/generate-report`, data);
    } catch (e) {
      return null;
    }
  },
}